import type { FigureResponse } from "@patent-studio/api-types";

/** What naming and previewing a figure read: a set-aside figure has these too. */
export type ShownFigure = Pick<
  FigureResponse,
  "file_id" | "label" | "original_filename" | "thumbnail_url"
>;

/**
 * How a figure is referred to out loud and in a control's name.
 *
 * Its own module rather than the card's, because the card draws the preview and
 * the preview names its trigger: leaving the helper on the card would have the
 * two importing each other. Every surface that has to say which figure it means
 * reads it from here, so one figure keeps one name.
 */
export function named(figure: ShownFigure): string {
  return figure.label === null
    ? figure.original_filename
    : `FIG. ${figure.label}, ${figure.original_filename}`;
}
